import { Component, Emit, Model, Prop, Vue } from 'vue-property-decorator';
import { REFERENCE_TAB_SELECT } from '@/constants';
import GoModal from '@/core/go-modal/go-modal.vue';

@Component({
  computed: {
    REFERENCE_TAB_SELECT() {
      return REFERENCE_TAB_SELECT;
    },
  },
  components: {
    'go-modal': GoModal,
  },
})
export default class PopupSelectTypeReference extends Vue {
  @Model('open', { type: Boolean, required: true }) open!: boolean;
  referenceTabSelected = null;

  @Emit('select-reference-type') selectedReferenceTab(selectedReferenceTab: string) {
    this.referenceTabSelected = null;
    return selectedReferenceTab;
  }

  @Emit('close') close() {
    this.referenceTabSelected = null;
  }
}
